// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;As the hills stand about Jerusalem,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;so the Lord stands round about his people,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;from this time forth for evermore.<br> </p> </div></div>";
// Exports
module.exports = code;